import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { ImageIcon, Loader2 } from "lucide-react";

export default function CardImage({ path, className }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    let objectUrl;
    if (!path) {
      setLoading(false);
      setFailed(true);
      return;
    }
    setLoading(true);
    setFailed(false);
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setFailed(true);
        setLoading(false);
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (loading)
    return (
      <div className={`flex items-center justify-center bg-slate-800 ${className}`}>
        <Loader2 className="w-5 h-5 text-slate-500 animate-spin" />
      </div>
    );
  if (failed || !url)
    return (
      <div className={`flex items-center justify-center bg-slate-800 ${className}`}>
        <ImageIcon className="w-6 h-6 text-slate-600" />
      </div>
    );
  return <img src={url} alt="Business card" className={className} />;
}
